import { render, staticRenderFns } from "./changeProfile.vue?vue&type=template&id=61dc1828&scoped=true"
import script from "./changeProfile.vue?vue&type=script&lang=js"
export * from "./changeProfile.vue?vue&type=script&lang=js"
import style0 from "./changeProfile.vue?vue&type=style&index=0&id=61dc1828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc1828",
  null
  
)

export default component.exports